var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "check",
      class: {
        "check--disabled": _vm.disabled,
        "check--error": _vm.errors.length,
        "check--checked": _vm.checked,
        "check--indeterminate": _vm.indeterminate,
      },
    },
    [
      _c(
        "span",
        { staticClass: "check__state" },
        [
          [
            _vm.checked
              ? _c("IconComponent", { attrs: { name: "check-line" } })
              : _vm._e(),
          ],
        ],
        2
      ),
      _c("input", {
        attrs: {
          type: "checkbox",
          disabled: _vm.disabled,
          indeterminate: _vm.indeterminate,
        },
        domProps: { checked: _vm.checked },
        on: {
          change: function ($event) {
            return _vm.$emit("change", $event.target.checked)
          },
        },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }